import React from "react";
import '../CardList.scss'
import {useDispatch, useSelector} from 'react-redux';
import AddIcon from "@material-ui/icons/Add";
import {deleteBgItem} from "../../../api/common";
import {competenceLevels} from "../../../db/models/const";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import {competences as competencesDataset} from "../../../db/datasets/competences";
import {openDialog} from "../../../slices/dialog";
import ButtonCircle from "../../Common/ButtonCircle";
import {EditRmCompetence} from "../../Dialog/Rm/EditCompetence";
import {selectSelectedRm} from "../../../slices/selected";
import {sanitizeUrl} from "../../../helpers/misc";
import "./style.scss";
import {useTranslation} from "react-i18next";
import {selectRole} from "../../../slices/profile";

export const RmCompetences = (props) => {
    const dispatch = useDispatch();
    const competences = props.competences;
    const rm = useSelector(selectSelectedRm);
    const role = useSelector(selectRole);
    const editable = role === "company";
    const {t} = useTranslation();

    const addBgItem = (type) => {
        dispatch(openDialog({
            Content: EditRmCompetence,
            title: t("company_rm_editComp_title"),
            props: {
                docId: rm.id
            },
            closable: true
        }));
    };

    return (
        <div className="competences card">
            <div className={competences.length > 0 ? "card__header border" : 'card__header'}>
                <h2>{t("company_rm_comp_title")}</h2>
                {editable && <ButtonCircle onClick={() => addBgItem("COMP")}><AddIcon/></ButtonCircle>}
            </div>
            <div className="card__content">
                {competences.map((competence) => (
                    <RmCompetence
                        key={competence.id}
                        competence={competence}
                        editable={editable}
                        missing={false}
                    />
                ))}
            </div>
        </div>
    );
};

export const RmCompetence = ({competence, editable, missing}) => {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const role = useSelector(selectRole);
    const materials = Object.values(competence?.materials || {});
    const title = competence?.labelId != null ? competencesDataset[competence.labelId].label : "";
    const level = competence?.levelId != null ? t(competenceLevels[competence.levelId].label) : "";
    const certificate = competence?.certificate || "";
    const optional = competence?.importance === 2 ? true : false;
    const rm = useSelector(selectSelectedRm);

    const onUpdateBgItem = () => {
        if (!competence || !rm?.id) return;

        dispatch(openDialog({
            Content: EditRmCompetence,
            title: "Edita Competenza",
            props: {
                competence,
                docId: rm.id
            },
            closable: true
        }));
    };

    const onItemDelete = () => {
        if (!rm?.id) return;
        deleteBgItem(rm.id, competence.id, "COMP", role);
    };

    return (
        <div className={missing === true ? "card__item missing" : "card__item"}>
            <div className="card__item__content">
                <h2 className="title">{title}</h2>
                <p className="bold">{level}</p>
                {optional && <p>{t("company_rm_optional")}</p>}
                <p className="regular">{certificate}</p>
                {materials.length > 0 &&
                    materials.map(mat =>
                        <div key={mat.id}>
                            <p>{mat.title}</p>
                            <a className="link" target="_blank" rel="noopener noreferrer"
                               href={sanitizeUrl(mat.link)}>{mat.link?.substring(0, 30)}</a>
                        </div>
                    )}
            </div>
            {editable && (
                <div className="card__item__actions">
                    <ButtonCircle onClick={() => onUpdateBgItem()}><EditIcon/></ButtonCircle>
                    <ButtonCircle onClick={() => onItemDelete()}><DeleteIcon/></ButtonCircle>
                </div>
            )}
        </div>
    );
};

export default RmCompetences;